/* Skin2Glow Journal article enhancements. Plain asset file, no template tags.
   Reads its labels from data attributes on .s2g-jr[data-jr-article]. */
(function () {
  function article(root) {
    var prose = root.querySelector('.jr-prose');
    if (!prose) return;
    var faqRe = new RegExp(root.getAttribute('data-faq') || 'faq', 'i');

    // two or more "h3 + list" pairs in a row (morning / evening routine) become side-by-side cards
    Array.prototype.slice.call(prose.children).forEach(function (el) {
      if (el.tagName !== 'H3' || el.parentNode !== prose) return;
      var pairs = [], n = el;
      while (n && n.tagName === 'H3' && n.nextElementSibling && n.nextElementSibling.tagName === 'UL') {
        pairs.push([n, n.nextElementSibling]);
        n = n.nextElementSibling.nextElementSibling;
      }
      if (pairs.length < 2) return;
      var duo = document.createElement('div');
      duo.className = 'jr-duo';
      el.parentNode.insertBefore(duo, el);
      pairs.forEach(function (p) { var s = document.createElement('section'); s.appendChild(p[0]); s.appendChild(p[1]); duo.appendChild(s); });
    });

    // FAQ: questions fold out, on a lavender panel
    var faqH = Array.prototype.slice.call(prose.children).filter(function (k) { return k.tagName === 'H2' && faqRe.test(k.textContent); })[0];
    if (faqH) {
      var panel = document.createElement('div'); panel.className = 'jr-faqp';
      var box = document.createElement('div'); box.className = 'jr-faq';
      var n = faqH.nextElementSibling, cur = null;
      while (n && n.tagName !== 'H2' && !n.classList.contains('jr-fig')) {
        var next = n.nextElementSibling;
        if (n.tagName === 'H3') {
          cur = document.createElement('details');
          var sm = document.createElement('summary'); sm.innerHTML = n.innerHTML;
          cur.appendChild(sm); cur.appendChild(document.createElement('div'));
          box.appendChild(cur); n.parentNode.removeChild(n);
        } else if (cur) { cur.lastElementChild.appendChild(n); }
        n = next;
      }
      faqH.parentNode.insertBefore(panel, faqH);
      panel.appendChild(faqH); panel.appendChild(box);
    }

    // guide contents from the section headings
    var heads = Array.prototype.slice.call(prose.querySelectorAll('h2'));
    if (heads.length > 2) {
      var toc = document.createElement('nav');
      toc.className = 'jr-toc';
      toc.setAttribute('aria-label', root.getAttribute('data-toc') || '');
      var b = document.createElement('b'); b.textContent = root.getAttribute('data-toc') || '';
      var ol = document.createElement('ol');
      heads.forEach(function (h, i) {
        h.id = h.id || 'jr-s' + (i + 1);
        var li = document.createElement('li'), a = document.createElement('a');
        a.href = '#' + h.id; a.textContent = h.textContent; li.appendChild(a); ol.appendChild(li);
      });
      toc.appendChild(b); toc.appendChild(ol);
      prose.insertBefore(toc, prose.firstChild);
    }

    // drop cap on the opening paragraph
    var first = Array.prototype.slice.call(prose.children).filter(function (k) { return k.tagName === 'P'; })[0];
    if (first) first.classList.add('jr-lead');

    // reading progress
    var bar = root.querySelector('.jr-progress');
    if (bar) {
      var ticking = false;
      var update = function () {
        var r = prose.getBoundingClientRect();
        var w = Math.min(1, Math.max(0, (window.innerHeight - r.top) / (r.height + window.innerHeight * 0.2)));
        bar.style.width = (w * 100).toFixed(1) + '%';
        ticking = false;
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
      update();
    }
  }

  function index(root) {
    var chips = root.querySelectorAll('.jr-chip');
    var items = root.querySelectorAll('[data-jr-topic]');
    Array.prototype.forEach.call(chips, function (c) {
      c.addEventListener('click', function () {
        var t = c.getAttribute('data-topic');
        /* 2026-10-02 Ales: a topic with one guide opens that guide, no second click */
        var hits = Array.prototype.filter.call(items, function (it) { return it.getAttribute('data-jr-topic') === t; });
        if (t !== 'all' && hits.length === 1) {
          var a = hits[0].matches('a[href]') ? hits[0] : hits[0].querySelector('a[href]');
          if (a) { location.href = a.href; return; }
        }
        Array.prototype.forEach.call(chips, function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        Array.prototype.forEach.call(items, function (it) {
          if (t === 'all' || it.getAttribute('data-jr-topic') === t) it.removeAttribute('data-jr-hidden');
          else it.setAttribute('data-jr-hidden', '');
        });
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.s2g-jr[data-jr-article]'), article);
    Array.prototype.forEach.call(document.querySelectorAll('.s2g-jr[data-jr-index]'), index);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
